import { createContext, useContext, type ReactNode } from 'react'

/**
 * `catalogue` (default): the full shopping panel, in the side drawer.
 * `proposal`: `ProposalProductModal` — product information only, in a centred
 * modal: no add to quote, likes, favourites, catalogue prices or link away from
 * the page, so nothing contradicts the prices quoted on a proposal.
 */
export type ProductPreviewMode = 'catalogue' | 'proposal'

const ProductPreviewModeContext = createContext<ProductPreviewMode>('catalogue')

export const ProductPreviewModeProvider = ({
  mode,
  children,
}: {
  mode: ProductPreviewMode
  children: ReactNode
}) => (
  <ProductPreviewModeContext.Provider value={mode}>
    {children}
  </ProductPreviewModeContext.Provider>
)

// eslint-disable-next-line react-refresh/only-export-components
export const useProductPreviewMode = () => useContext(ProductPreviewModeContext)
